import { render, staticRenderFns } from "./cnkiDetail.vue?vue&type=template&id=2500dff4&scoped=true&"
import script from "./cnkiDetail.vue?vue&type=script&lang=js&"
export * from "./cnkiDetail.vue?vue&type=script&lang=js&"
import style0 from "./cnkiDetail.vue?vue&type=style&index=0&id=2500dff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500dff4",
  null
  
)

export default component.exports